import {VotingType} from "@/entities/voting/VotingType";

export abstract class NewEntityVotingModel {
    branchId: number;
    abstract type: VotingType;

    protected constructor(branchId: number) {
        this.branchId = branchId;
    }
}
